import { Link } from 'react-router-dom';
import { useReveal } from '../../hooks/useReveal';

export const HomeEnrollmentCta = () => {
  const sectionRef = useReveal();
  const ctasRef = useReveal();
  return (
    <section className="py-24 md:py-32 bg-[#43b6b8] relative overflow-hidden" data-testid="cta-banner">
      {/* Subtle gold accent shapes */}
      <div className="absolute -top-20 -right-20 w-96 h-96 bg-[#d3b163]/15 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute -bottom-20 -left-20 w-80 h-80 bg-white/5 rounded-full blur-3xl pointer-events-none"></div>

      <div ref={sectionRef} className="reveal relative max-w-4xl mx-auto px-6 sm:px-8 md:px-12 text-center">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-white mb-5 leading-tight">
          ¿Listo para formar parte de nuestra familia?
        </h2>
        <div className="w-16 h-[3px] bg-[#d3b163] mx-auto mb-6 rounded-full"></div>
        <p className="text-base sm:text-lg text-white/95 mb-10 max-w-2xl mx-auto leading-relaxed">
          Descubre cómo podemos apoyar el desarrollo académico y personal de tu hijo en un ambiente seguro y personalizado.
        </p>
        <div
          ref={ctasRef}
          style={{ transitionDelay: '120ms' }}
          className="reveal-pop flex flex-col sm:flex-row gap-4 sm:gap-5 justify-center"
        >
          <Link
            to="/informacion-admision"
            data-testid="cta-solicita-info-banner"
            className="group inline-flex items-center justify-center gap-2 bg-[#d3b163] hover:bg-[#b89548] text-white px-10 py-[18px] rounded-full font-semibold transition-all active:scale-[0.97] shadow-[0_12px_36px_-8px_rgba(211,177,99,0.7)] hover:shadow-[0_16px_44px_-6px_rgba(211,177,99,0.9)] hover:-translate-y-0.5"
          >
            Solicita Información
            <span className="transition-transform group-hover:translate-x-1">→</span>
          </Link>
          <Link
            to="/contacto"
            className="inline-flex items-center justify-center bg-white/95 text-[#43b6b8] hover:text-[#359a9c] px-10 py-[18px] rounded-full font-semibold hover:bg-white transition-all"
          >
            Contáctanos
          </Link>
        </div>
      </div>
    </section>
  );
};
